
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import MaskedPhoneInput from "@/components/common/MaskedPhoneNew.vue";
import FormWrapper from "@/components/form/FormWrapper.vue";
import FormGroup from "@/components/form/FormGroupCustom.vue";
import UIButton from "@/components/button/ui-button.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import DeleteGray from "@/components/icons/DeleteGray.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";

@Component({
  components: {
    ModalContent,
    ModalFullScreen,
    CrossIconHover,
    FormWrapper,
    MaskedPhoneInput,
    FormGroup,
    UIButton,
    CrossIcon,
    DeleteGray,
    LoadingOverlay,
  },
})
export default class ManagementAddContractorInfo extends Vue {
  @Prop({ type: String, required: false })
  readonly phone?: String;

  isHovered: boolean = false;
  updatedPhone: string = this.phone ? this.phone.toString() : "";

  closeModal(): void {
    this.$emit("close");
  }

  addPhone() {
    if (this.updatedPhone?.length > 0) {
      this.$emit("edit-phone", {
        oldName: this.phone,
        newName: this.updatedPhone,
      });
    } else {
      this.$emit("add-phone", this.phone);
    }
    this.$emit("close");
  }

  editPhone() {
    this.$emit("edit-phone", {
      oldName: this.updatedPhone,
      newName: this.phone,
    });
    this.closeModal();
  }
}
